<template>
  <template v-if="seminarDetails">
    <div class="text-subtitle">{{ seminarDetails.title }}</div>
    <div class="border-t border-b border-dashed border-gray-300 py-2 mb-6">
      <div class="v-html whitespace-pre-wrap" v-html="seminarDetails.summary" />
    </div>
    <div class="v-html whitespace-pre-wrap mb-6" v-html="seminarDetails.body" />
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { SeminarAttributes } from '@/types/models/seminar'

export default defineComponent({
  props: {
    seminarDetails: {
      type: Object as PropType<SeminarAttributes | undefined>,
      'default': () => (undefined),
    }
  },
})
</script>
